/**
 * Dev-only logger. All calls become no-ops in production builds so we don't
 * leak internal state to end users or clutter their consoles.
 *
 * Usage:
 *   import { logger } from "@/lib/logger";
 *   logger.warn("Something odd happened:", err);
 *   logger.info("Loaded", data);
 *
 * Swap the implementation for Sentry / Datadog by editing this one file.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
};

export default logger;
